import React, { useState, useEffect } from 'react';
import Footer from "../../../components/Footer/Footer";
import { useScrollHeader } from '../../../hooks';
import { Swiper, SwiperSlide } from 'swiper/react';
import './eyepal.less';
import 'swiper/css';
import 'swiper/css/pagination';

function Eyepal({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发

  const imgList = [
    {
      img: '/images/products/eyepal-img.png',
      imgItem: [
        '/images/products/eyepal-img-1.jpg',
        '/images/products/eyepal-img-2.jpg',
        '/images/products/eyepal-img-3.jpg',
      ]
    },
    {
      img: '/images/products/eyepal-img-color-2.png',
      imgItem: [
        '/images/products/eyepal-img-1-color2.png',
        '/images/products/eyepal-img-2-color2.png',
        '/images/products/eyepal-img-3-color2.png',
      ]
    },
    {
      img: '/images/products/eyepal-img-color-1.png',
      imgItem: [
        '/images/products/eyepal-img2-color-1.png',
        '/images/products/eyepal-img3-color-1.png',
        '/images/products/eyepal-img4-color-1.png',
      ]
    }
  ]
  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(0);
  const [direction, setDirection] = useState('next'); // 用于管理动画进出方向
  const goToPrev = () => {
    // setCurrentIndex((prev) => (prev === 0 ? imgList.length - 1 : prev - 1));
    if (currentIndex !== 0) {
      setPrevIndex(currentIndex);
      setCurrentIndex(currentIndex - 1)
      setDirection('prev');
    }
  };
  const goToNext = () => {
    // setCurrentIndex((prev) => (prev === imgList.length - 1 ? 0 : prev + 1));
    if (currentIndex !== imgList.length - 1) {
      setPrevIndex(currentIndex);
      setCurrentIndex(currentIndex + 1)
      setDirection('next');
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
  }, []);

  return (
    <div className="Eyepal">
      <div className='Eyepal_cover'>
        <div className="Eyepal_cover-bgi2 flex_center">
          <img
            src='./images/eyepal/eyepal-banner1.png'
            alt=''
          />
        </div>
        <div className="Eyepal_cover-content">
          <img
            className="Eyepal_cover-logo"
            src='./images/eyepal/eyepal-logo.svg'
            alt=''
          />
          <div className="Eyepal_cover-title ta_c">可视温润舒眼仪</div>
        </div>
      </div>
      <div className='Eyepal_section1'>
        {/* PC端 */}
        <div className='Eyepal_section1-Pc'>
          <img
            style={{ width: '100%' }}
            src='./images/eyepal/gongneng-1080.png'
            alt=''
          />
          <img
            className='Eyepal_section1-img'
            src='./images/eyepal/eyepal-img1.png'
            alt=''
          />
          <div className="Eyepal_section1-block">
            <ul>
              <li>有效增加泪河高度</li>
              <li>延长泪膜破裂时间</li>
              <li>增加泪膜脂层厚度</li>
            </ul>
          </div>
        </div>
        {/* 移动端 */}
        <div className='Eyepal_section1-Mobile'>
          <img
            style={{ width: '100%' }}
            src='./images/eyepal/gongneng-390.png'
            alt=''
          />
          <div className="Eyepal_section1-blockMobile">
            <img
              style={{ width: '100%' }}
              src='./images/eyepal/eyepal-img1.png'
              alt=''
            />
            <ul>
              <li>有效增加泪河高度</li>
              <li>延长泪膜破裂时间</li>
              <li>增加泪膜脂层厚度</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="Eyepal_section2">
        <div className="Eyepal_section2-top pageMargin">
          <div className="Eyepal_section2-topItem flex_center">轻量便携</div>
          <div className="Eyepal_section2-topItem flex_center">智能定制</div>
          <div className="Eyepal_section2-topItem flex_center">效果舒适</div>
        </div>
        <div className="Eyepal_section2-img">
          <img
            style={{ width: '100%' }}
            src='./images/eyepal/eyepal-img2.png'
            alt=''
          />
        </div>
        <div className='pageMargin Eyepal_section2-block'>
          <div className='Eyepal_section2-title'>可视温润舒眼仪</div>
          <div className='Eyepal_section2-subTitle'>告别不可视 | 告别长周期</div>
        </div>
      </div>
      <div className="Eyepal_section3">
        <div className='flex_row flex_jc-c of_hidden'>
          {imgList.map((item, index) =>
            <div
              key={index}
              className={`Eyepal_section3-img ${index === currentIndex
                ? direction === 'next'
                  ? 'slide-in-next'
                  : 'slide-in-prev'
                : index === prevIndex
                  ? direction === 'next'
                    ? 'slide-out-next'
                    : 'slide-out-prev'
                  : ''
                }`}
              style={{ width: '100%', display: index === currentIndex ? '' : 'none' }}
            >
              <img
                style={{ width: '100%' }}
                src={item.img}
                alt=''
              />
            </div>)}
        </div>
        {/* PC端 */}
        <div className="Eyepal_section3-blockPc">
          <div className='flex_row flex_jc-fe pageMargin' style={{ marginTop: '-6%' }}>
            <div
              className={`Eyepal_section3-sliderBtn ${currentIndex === 0 ? 'disabled' : ''}`}
              onClick={goToPrev}
            >
              <img
                className='Eyepal_section3-sliderBtnIcon'
                src='./images/home/whiteLeftIcon.png'
                alt=''
              />
            </div>
            <div className='flex_row flex_ai-c'>
              {imgList.map((_, index) => (
                <div
                  key={index}
                  className={`Eyepal_section3-indicator ${index === currentIndex ? 'active' : ''}`}
                />
              ))}
            </div>
            <div
              className={`Eyepal_section3-sliderBtn ${currentIndex === imgList.length - 1 ? 'disabled' : ''}`}
              onClick={goToNext}
            >
              <img
                className='Eyepal_section3-sliderBtnIcon'
                src='./images/home/whiteRightIcon.png'
                alt=''
              />
            </div>
          </div>
          <div className='pageMargin flex_row flex_jc-sb gap_16 pb_65'>
            <div className='flex_row flex_ai-c gap_20 mt_40'>
              <div
                className="Eyepal_section3-btn"
                style={{
                  border: currentIndex === 0 ? '4px solid #B18661' : '4px solid #FFFFFF',
                  background: '#DED3C1'
                }}
                onClick={() => {
                  setDirection('next');
                  setCurrentIndex(0)
                }}
              ></div>
              <div
                className="Eyepal_section3-btn"
                style={{
                  border: currentIndex === 1 ? '4px solid #05139a' : '4px solid #FFFFFF',
                  background: '#585C85'
                }}
                onClick={() => {
                  setDirection('next');
                  setCurrentIndex(1)
                }}
              ></div>
              <div
                className="Eyepal_section3-btn"
                style={{
                  border: currentIndex === 2 ? '4px solid #3f257d' : '4px solid #FFFFFF',
                  background: '#877CA2'
                }}
                onClick={() => {
                  setDirection('next');
                  setCurrentIndex(2)
                }}
              ></div>
            </div>
            <div className='flex_row flex_ai-c gap_16 mt_40'>
              {imgList[currentIndex].imgItem.map((url, index) =>
                <div key={index} className='Eyepal_section3-imgItem'>
                  <img
                    style={{ width: '100%' }}
                    src={url}
                    alt=''
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {/* 移动端 */}
        <div className="Eyepal_section3-blockMobile flex_col of_hidden">
          <div className='flex_col flex_ai-c'>
            <div className='flex_row flex_ai-c gap_13 mt_33'>
              <div
                className="Eyepal_section3-btn"
                style={{
                  border: currentIndex === 0 ? '4px solid #B18661' : '4px solid #FFFFFF',
                  background: '#DED3C1'
                }}
                onClick={() => {
                  setDirection('next');
                  setCurrentIndex(0)
                }}
              ></div>
              <div
                className="Eyepal_section3-btn"
                style={{
                  border: currentIndex === 1 ? '4px solid #05139a' : '4px solid #FFFFFF',
                  background: '#585C85'
                }}
                onClick={() => {
                  setDirection('next');
                  setCurrentIndex(1)
                }}
              ></div>
              <div
                className="Eyepal_section3-btn"
                style={{
                  border: currentIndex === 2 ? '4px solid #3f257d' : '4px solid #FFFFFF',
                  background: '#877CA2'
                }}
                onClick={() => {
                  setDirection('next');
                  setCurrentIndex(2)
                }}
              ></div>
            </div>
            {/* <div className='flex_row flex_ai-c mt_39'>
              {imgList.map((_, index) => (
                <div
                  key={index}
                  className={`Eyepal_section3-indicator ${index === currentIndex ? 'active' : ''}`}
                />
              ))}
            </div> */}
          </div>
          <div className='mt_20' style={{ marginLeft: '5.1%' }}>
            <Swiper
              slidesPerView={'auto'}
              centeredSlides={true} // 居中显示
              className="Products_swiper"
            >
              {imgList[currentIndex].imgItem.map((url, index) => <SwiperSlide key={index}>
                <img
                  className='Eyepal_section3-imgItem'
                  style={{ width: '100%' }}
                  src={url}
                  alt=""
                />
              </SwiperSlide>)}
            </Swiper>
          </div>
        </div>
      </div>
      <div className="Eyepal_section4 flex_col flex_ai-c">
        <div className='pageMargin Eyepal_section4-block'>
          <div className='Eyepal_section4-title Eyepal_linear-gradient'>适用人群及场景</div>
          {/* PC端 */}
          <div className="Eyepal_section4-imgPc">
            <img
              style={{ width: '100%' }}
              src='./images/eyepal/renqun.png'
              alt=''
            />
          </div>
          {/* 移动端 */}
          <div className="Eyepal_section4-imgMobile flex_col flex_ai-c">
            <img
              style={{ width: '82%' }}
              src='./images/eyepal/renqun-390.png'
              alt=''
            />
          </div>
          <div className="Arta_tip" style={{ background: '#ffffff' }} >本产品为在研产品，不可用于诊疗活动，科普内容仅供参考，不构成任何医疗建议。</div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Eyepal;